import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Info = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="#303032"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path
          d="M21.25 12c0 6.937-2.313 9.25-9.25 9.25S2.75 18.937 2.75 12 5.063 2.75 12 2.75s9.25 2.313 9.25 9.25"
          clipRule="evenodd"
        />
        <path d="M12 15.895V12M12.005 8.5h-.01" />
      </g>
    </svg>
  );
};
export default Info;
